import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./adminLogin.css";
import logo from "../../assets/icons/18.png";
import loginBg from "../../assets/icons/loginBg.png";

function ManagerLogin() {
  const navigate = useNavigate();
  const [login, setLogin] = useState({ email: "", password: "" });
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  // If already logged in, redirect to dashboard (don't show manager login page)
  const [showForm, setShowForm] = useState(false);
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      navigate("/admin/dashboard", { replace: true });
    } else {
      setShowForm(true);
    }
  }, [navigate]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setLogin((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      const baseUrl = apiUrl.endsWith("/") ? apiUrl.slice(0, -1) : apiUrl;
      const response = await axios.post(`${baseUrl}/api/manager/login`, login);
      if (response.data.success && response.data.data && response.data.data.token) {
        localStorage.setItem("token", response.data.data.token);
        const userObj = { ...response.data.data };
        localStorage.setItem("user", JSON.stringify(userObj));
        const name = userObj.fullName || userObj.name || userObj.first_name || userObj.email || "Manager";
        localStorage.setItem("userName", name);
        toast.success(`Welcome, ${name} (Manager)`);
        navigate("/admin/dashboard");
      } else {
        toast.error(response.data.message || "Invalid manager credentials");
      }
    } catch (error) {
      if (error.response && error.response.data && error.response.data.message) {
        const msg = error.response.data.message;
        toast.error(msg === "Account is deactivated" ? "This account is disabled. Contact your administrator." : msg);
      } else {
        toast.error("Server error. Please try again.");
      }
    } finally {
      setIsLoading(false);
    }
  };

  if (!showForm) return null;

  return (
    <div className="admin-login-root">
      <div
        className="admin-login-background"
        style={{ backgroundImage: `url(${loginBg})` }}
      >
        <div className="admin-login-overlay"></div>
      </div>

      <div className="admin-login-container">
        <form className="admin-login-form" onSubmit={handleSubmit}>
          <div className="admin-login-header">
            <img src={logo} alt="OnSitePro Logo" className="admin-login-logo" />
            <h2 className="admin-login-title">Manager Login</h2>
            <p className="admin-login-subtitle">Managers, please login here</p>
          </div>

          <div className="admin-login-input-group">
            <div className="admin-login-input-wrapper">
              <i className="fa fa-envelope admin-login-input-icon"></i>
              <input
                type="email"
                name="email"
                placeholder="Email address"
                value={login.email}
                onChange={handleChange}
                required
                className="admin-login-input"
                disabled={isLoading}
              />
            </div>

            <div className="admin-login-input-wrapper">
              <i className="fa fa-lock admin-login-input-icon"></i>
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                placeholder="Password"
                value={login.password}
                onChange={handleChange}
                required
                className="admin-login-input admin-login-password-input"
                disabled={isLoading}
              />
              <button
                type="button"
                className="admin-login-password-toggle"
                onClick={() => setShowPassword(!showPassword)}
                disabled={isLoading}
                aria-label={showPassword ? "Hide password" : "Show password"}
              >
                <i className={`fa ${showPassword ? "fa-eye-slash" : "fa-eye"}`}></i>
              </button>
            </div>
          </div>

          <button
            type="submit"
            className="admin-login-btn"
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <span className="admin-login-spinner"></span>
                Logging in...
              </>
            ) : (
              "Login"
            )}
          </button>
        </form>
      </div>
    </div>
  );
}

export default ManagerLogin;
